import { Component } from "react";
import Layout from "../../layout/Layout";
import DepartmentPicker from "./DepartmentPicker";
import EmployeePicker from "../employee/EmployeePicker";
import { api } from "../../utils/Api";
import axios from "axios";

export default class NewDepartment extends Component {
    constructor(props){
        super(props);
        this.state = {
            name: '',
            pDepartment:'',
            head:'',
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit = async (e) => {
        e.preventDefault();

        let body = {
            name: this.state.name
        }

        if(this.state.pDepartment !== '') body.pDepartment = this.state.pDepartment
        if(this.state.head !== '') body.head = this.state.head

        const url = api + `/department`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            await axios.post(url, body)
            this.props.history.push('/departments')
        } catch (err) {
            console.error(err.message)
            return null
        }
        
    }

    // change department
    onChangeDepartment = selectedDepartment => {
        if (selectedDepartment) {
            this.setState({
                pDepartment: selectedDepartment.value,
            })
        }
    }

    // change employee head
    onChangeEmployee = selectedEmployee => {
        if (selectedEmployee) {
            this.setState({
                head: selectedEmployee.value,
            })
        }
    }

    RenderNewDepartment = () => (
        <form onSubmit={this.onSubmit}> 
            <div className="form-group row">
                <div className="col-sm-12">
                    <label className="text-muted">Name</label>
                    <input
                    name = 'name'
                    type = 'text'
                    value = {this.state.name}
                    onChange={e => this.setState({name:e.target.value})}
                    placeholder="Name"
                    className="form-control"
                    required
                    />
                </div>
                <div className='col-sm-6'>
                    <label className='text-muted'>Parent Department</label>
                    <DepartmentPicker action={this.onChangeDepartment} value={this.state.pDepartment} />
                </div>
                <div className='col-sm-6'>
                    <label className='text-muted'>Employee Head</label>
                    <EmployeePicker action={this.onChangeEmployee} value={this.state.head} />
                </div>
                &nbsp;
            </div>
            
            <button className="btn btn-success" type="submit">Add</button>
        </form>
    )

    render(){
        return <Layout
        title="Department"
        description="Create New Department"
        className={'container col-md-8 offset-md-2'}
        >
            {this.RenderNewDepartment()}
        </Layout>
    }
}